import { FTMarketIds } from "../../typings";
export const isMarketType = (marketTypeId, marketType) => {
    return marketTypeId.startsWith(FTMarketIds[marketType]);
};
//# sourceMappingURL=isMarketType.js.map